'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _actions = require('../../../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _utils = require('../../../components/utils');

var _utils2 = _interopRequireDefault(_utils);

var _linksoftAlbatros = require('linksoft-albatros');

var _Select = require('linksoft-albatros/src/components/Select2');

var _Select2 = _interopRequireDefault(_Select);

var _InlineTooltip = require('../InlineTooltip');

var _InlineTooltip2 = _interopRequireDefault(_InlineTooltip);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _ajax = require('linksoft/utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _storageProvider = require('../../../../storageProvider');

var _storageProvider2 = _interopRequireDefault(_storageProvider);

var _common = require('../../../../common');

var _common2 = _interopRequireDefault(_common);

var _ModalDialog = require('../ModalDialog');

var _ModalDialog2 = _interopRequireDefault(_ModalDialog);

var _plain = require('redux-form/lib/structure/plain');

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App', 'Common');

function mapStateToProps(state) {
    var options = (0, _linksoftAlbatros.getCartOptions)(state.cart);

    var retObject = {
        ulozenkaKey: _common2.default.findDeliveryRefSafe(state.cart, 'ulozenkaKey'),
        zasilkovnaKey: _common2.default.findDeliveryRefSafe(state.cart, 'zasilkovnaKey'),
        zasilkovnaCzKey: _common2.default.findDeliveryRefSafe(state.cart, 'zasilkovnaCzKey'),
        zasilkovnaCzDeliveryKey: _common2.default.findDeliveryRefSafe(state.cart, 'zasilkovnaCzDeliveryKey'),
        pplParcelShopKey: _common2.default.findDeliveryRefSafe(state.cart, 'pplParcelShopKey'),
        balikovnaKey: _common2.default.findDeliveryRefSafe(state.cart, 'balikovnaKey'),
        balikovnaUrl: _common2.default.findDeliveryRefSafe(state.cart, 'balikovnaUrl'),
        paymentTypeId: options.paymentTypeId,
        deliveryTypeId: options.deliveryTypeId,
        phoneCountryCode: options.phoneCountryCode,
        pickupPlaceId: options.pickupPlaceId,
        pickupPlaceName: state.cart.pickupPlaceName || (state.cart.pickupPlace || {}).name,
        allowedDeliveryPayments: state.cart.allowedDeliveryPayments,
        processing: state.cart.processing
    };

    //for testing on localhost, when webpack replace b2c by localhost:3000 or similar
    if (retObject.balikovnaUrl.indexOf('localhost') > -1) retObject.balikovnaUrl = 'https://b2c.cpost.cz/locations/?type=BALIKOVNY';

    return retObject;
}

var mapDispatchToProps = {
    saveOptions: _actions2.default.saveOptions,
    setProcessing: _actions2.default.setProcessing,
    updateDeliveryType: _actions2.default.updateDeliveryType,
    restoreDeliveryAndFreeItems: _actions2.default.restoreDeliveryAndFreeItems
};

var DeliveryTypeItem = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
    (0, _inherits3.default)(DeliveryTypeItem, _React$PureComponent);

    function DeliveryTypeItem(props) {
        (0, _classCallCheck3.default)(this, DeliveryTypeItem);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DeliveryTypeItem.__proto__ || (0, _getPrototypeOf2.default)(DeliveryTypeItem)).call(this, props, false));

        _this.deliveryChanged = function (e) {
            // if there is no pickup place for current delivery type, try to get from cache
            var pupId = void 0,
                pupName = null;
            var id = parseInt(e.target.value, 10);
            var previousPpForDt = _storageProvider2.default.getValue(_this.getPreviousPupForKey(id), 15);
            if (previousPpForDt) {
                pupId = previousPpForDt.pickupPlaceId;
                pupName = previousPpForDt.pickupPlaceName;
            }

            if (id !== _this.props.deliveryTypeId) {
                _this.props.updateDeliveryType(id, pupId, pupName, _this.getPhoneCountryCode(id));
            }
        };

        _this.getPhoneCountryCode = function (deliveryTypeId) {
            return _utils2.default.getPhoneCountryCode(_this.props.collection, deliveryTypeId);
        };

        _this.navigateTo = function (url) {
            var a = document.createElement('a');
            if (a.click) {
                // HTML5 browsers and IE support click() on <a>, early FF does not.
                a.setAttribute('href', url);
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
            } else {
                // Early FF can, however, use this usual method
                // where IE cannot with secure links.
                window.location = url;
            }
        };

        _this.showHidePickupPlaceDialog = function (deliveryType, show) {
            var stateCopy = (0, _extends3.default)({}, _this.state);
            switch (deliveryType) {
                case 1:
                    stateCopy.displayBalikovnaDialog = show;
                    break;
                case 2:
                    stateCopy.displayPplDialog = show;
                    break;
            }

            _this.setState(stateCopy);
        };

        _this.balikovnaSelected = function (event) {
            if (_this.state.displayBalikovnaDialog && event.data && event.data.point && event.data.point.id && event.data.message === 'pickerResult') {
                _this.setState((0, _extends3.default)({}, _this.state, { displayBalikovnaDialog: false }));

                var point = event.data.point;
                point.id = point.id.replace(/[^\d]/, '');
                _this.pickupPlaceHandler(point);
                console.log(event);
            }
        };

        _this.showZasilkovnaDlg = function (deliveryTypeReference) {
            var country = _this.resolveLocalization(deliveryTypeReference);
            Packeta.Widget.close();
            Packeta.Widget.pick(packetaApiKey, _this.pickupPlaceHandler, {
                country: country,
                language: _this.resolveLocalization(deliveryTypeReference, true)
            });
        };

        _this.refreshPplDialog = function () {
            // react solution did not work
            if (!_this.state.canReload) return;

            _this.setState((0, _extends3.default)({}, _this.state, { canReload: false }));

            window.setTimeout(function () {
                var iframe = document.querySelector('.ppl-widget-wrapper > iframe');
                if (!iframe) return;
                iframe.src = _this.state.pplWidgetUrl;
                _this.setState((0, _extends3.default)({}, _this.state, { canReload: true }));
            }, 5000);
        };

        _this.getSelectedDeliveryItem = function () {
            var collection = _this.props.collection;

            if (!collection || collection.length === 0) return null;

            var item = collection[0];
            item.culture = _this.resolveLocalization(item.reference);
            return item;
        };

        _this.resolveLocalization = function (deliveryTypeReference) {
            var isLanguage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var czCode = isLanguage ? 'cs' : 'cz';
            return [_this.props.zasilkovnaCzDeliveryKey, _this.props.zasilkovnaCzKey].indexOf(deliveryTypeReference) >= 0 || !_utils2.default.skEnvironment() ? czCode : 'sk';
        };

        _this.pplParcelShopHandler = function () {
            if (_utils2.default.getQueryStringParam('type') === _this.props.pplParcelShopKey) {
                var point = {
                    id: _utils2.default.getQueryStringParam('id'),
                    name: _utils2.default.getQueryStringParam('name') + ', ' + _utils2.default.getQueryStringParam('address')
                };

                var _window$location = window.location,
                    origin = _window$location.origin,
                    pathname = _window$location.pathname;

                _this.props.restoreDeliveryAndFreeItems();
                _this.pickupPlaceHandler(point);
                window.history.pushState({}, document.title, origin + pathname);
            }
        };

        _this.pickupPlaceHandler = function (point) {
            var deliveryTypeId = _this.props.deliveryTypeId;


            if (point == null) {
                _this.props.updateDeliveryType(deliveryTypeId, null, null, _this.getPhoneCountryCode(deliveryTypeId));
            } else {
                var key = _this.getDeliveryTypeKey(deliveryTypeId, point.id);
                var cachedPickupPlace = _storageProvider2.default.getValue(key, 30);
                if (cachedPickupPlace) {
                    _this.updateAndCachePickupPlace(deliveryTypeId, cachedPickupPlace.id, cachedPickupPlace.name);
                } else {
                    _this.verifyPickupPlaceCallback(point);
                }
            }
        };

        _this.pickupSelectClick = function () {
            var item = _this.getSelectedDeliveryItem();
            _storageProvider2.default.setValueSession(_storageProvider2.default.sharedKeys.deliveryType, item);

            if ([_this.props.zasilkovnaKey, _this.props.zasilkovnaCzKey].indexOf(item.reference) >= 0) {
                _this.showZasilkovnaDlg(item.reference);
            } else if (item.reference === _this.props.pplParcelShopKey) {
                _this.showPPLParcelShopDlg();
            } else if (item.reference === _this.props.balikovnaKey) {
                _this.showHidePickupPlaceDialog(1, true);
            }
        };

        _this.deliveryTypes = function () {
            var _this$props = _this.props,
                deliveryTypeId = _this$props.deliveryTypeId,
                pickupPlaceId = _this$props.pickupPlaceId,
                pickupPlaceName = _this$props.pickupPlaceName,
                processing = _this$props.processing;


            var item = _this.getSelectedDeliveryItem();
            if (!_this.isSpecialDeliveryType(item.reference)) {
                return null;
            }
            if (deliveryTypeId !== item.id) {
                return null;
            }

            if (item.reference === _this.props.pplParcelShopKey) _this.pplParcelShopHandler();

            return _react2.default.createElement(
                'div',
                { className: 'row zasilkovna-result', onClick: _this.pickupSelectClick },
                _react2.default.createElement(
                    'div',
                    { className: 'col-md-9' },
                    pickupPlaceId == null ? Resx.App.PickupPlace_Select : processing === true ? 'Loading..' : pickupPlaceName
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-md-3' },
                    _react2.default.createElement(
                        'a',
                        { className: 'btn btn--gray btn--sm btn-pickup-select', onClick: _this.pickupSelectClick },
                        Resx.App.PickupSelectButton_Text
                    )
                )
            );
        };

        _this.placeChanged = function (e) {
            var id = parseInt(e.target.value, 10);
            id = id ? id : null;
            var prevId = _this.props.pickupPlaceId ? _this.props.pickupPlaceId : null;

            if (id !== prevId) {
                var text = e.target.options.length > 0 && e.target.selectedIndex > -1 ? e.target.options[e.target.selectedIndex].text : '-';

                _this.updateAndCachePickupPlace(_this.props.deliveryTypeId, id, text);
            }
        };

        _this.pickupPlaces = function () {
            var _this$props2 = _this.props,
                collection = _this$props2.collection,
                pickupPlaceId = _this$props2.pickupPlaceId;

            var item = _this.getSelectedDeliveryItem();
            if (item === null) return null;

            var places = collection.reduce(function (x, item) {
                item.pickupPlaces && item.pickupPlaces.forEach(function (pp) {
                    return x.push(pp);
                });
                return x;
            }, []);
            if (places.length > 1) {
                places.unshift({
                    id: '',
                    name: item.reference === _this.props.ulozenkaKey ? Resx.App.ChoosePickupPlace_City : Resx.App.ChoosePickupPlace
                });
            }
            return _react2.default.createElement(_Select2.default, {
                className: 'delivery-type--select2',
                options: places.map(function (item) {
                    return {
                        value: item.id,
                        label: item.name
                    };
                }),
                value: pickupPlaceId || '',
                onChange: _this.placeChanged
            });
        };

        _this.isSpecialDeliveryType = function (reference) {
            var _this$props3 = _this.props,
                zasilkovnaKey = _this$props3.zasilkovnaKey,
                zasilkovnaCzKey = _this$props3.zasilkovnaCzKey,
                pplParcelShopKey = _this$props3.pplParcelShopKey,
                balikovnaKey = _this$props3.balikovnaKey;

            var specialDeliveryTypes = [zasilkovnaKey, zasilkovnaCzKey, pplParcelShopKey, balikovnaKey];
            return specialDeliveryTypes.indexOf(reference) >= 0;
        };

        _this.state = {
            displayBalikovnaDialog: false,
            displayPplDialog: false,
            pplWidgetUrl: '/Cart/PplWidget/',
            canReload: true
        };
        window.addEventListener('message', _this.balikovnaSelected);
        return _this;
    }

    (0, _createClass3.default)(DeliveryTypeItem, [{
        key: 'showPPLParcelShopDlg',
        value: function showPPLParcelShopDlg() {
            var _this2 = this;

            // legacy solution, can be put back by adding element into HTML page, for now.
            // This can be removed, after new solution will be considered as feasible.
            if (document.getElementById('useOldPplSelection')) {
                var _window$location2 = window.location,
                    origin = _window$location2.origin,
                    pathname = _window$location2.pathname;

                var retUrl = '' + origin + pathname + '?type=' + this.props.pplParcelShopKey + '&id={0}&address={1}&name={2}&deliveryTypeId=' + this.props.deliveryTypeId;
                var url = 'https://www.pplbalik.cz/Main3.aspx?cls=KTMMap&CountryCode=CZ&KTMAddress=10000&ReturnUrl=' + encodeURIComponent(retUrl);
                this.navigateTo(url);
            }

            // new solution, later can be called directly
            this.showHidePickupPlaceDialog(2, true);
            window.addEventListener("message", function (event) {
                console.log(event);

                if (!event.data || !event.data.id) return;

                var point = {
                    id: event.data.code,
                    name: event.data.name
                };

                _this2.pickupPlaceHandler(point);
                _this2.showHidePickupPlaceDialog(2, false);
            });
        }
    }, {
        key: 'getDeliveryTypeKey',
        value: function getDeliveryTypeKey(deliveryTypeId, pointId) {
            return 'delivery_' + deliveryTypeId + '_pointId_' + pointId;
        }
    }, {
        key: 'getPreviousPupForKey',
        value: function getPreviousPupForKey(deliveryTypeId) {
            return 'previous_pup_for_' + deliveryTypeId;
        }

        //update state and also set this option to localStorage

    }, {
        key: 'updateAndCachePickupPlace',
        value: function updateAndCachePickupPlace(deliveryTypeId, ppId, ppName) {
            this.props.updateDeliveryType(deliveryTypeId, ppId, ppName, this.getPhoneCountryCode(deliveryTypeId));
            if (!deliveryTypeId || !ppId || !ppName) return;

            _storageProvider2.default.setValue(this.getPreviousPupForKey(deliveryTypeId), {
                pickupPlaceId: ppId,
                pickupPlaceName: ppName
            });
        }
    }, {
        key: 'verifyPickupPlaceCallback',
        value: function verifyPickupPlaceCallback(point) {
            var _this3 = this;

            var _props = this.props,
                deliveryTypeId = _props.deliveryTypeId,
                setProcessing = _props.setProcessing;


            setProcessing(true);
            var verifyUrl = '/odata/PickupPlaces?deliveryTypeId=' + deliveryTypeId + '&reference=' + point.id;
            (0, _ajax2.default)({ url: verifyUrl }).done(function (pickupPlace) {
                if (pickupPlace !== '') {
                    var key = _this3.getDeliveryTypeKey(deliveryTypeId, point.id);
                    _storageProvider2.default.setValue(key, pickupPlace);
                    _this3.updateAndCachePickupPlace(deliveryTypeId, pickupPlace.id, pickupPlace.name);
                    setProcessing(false);
                } else {
                    _this3.props.updateDeliveryType(deliveryTypeId, null, null, _this3.getPhoneCountryCode(deliveryTypeId));
                    sweetAlert({
                        type: 'error',
                        title: Resx.App.PickupPlace_Title,
                        text: Resx.App.PickupPlace_Text.replaceAll('{0}', point.name),
                        confirmButtonColor: '#DD6B55',
                        confirmButtonText: Resx.App.PickupPlace_Button
                    });
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props2 = this.props,
                collection = _props2.collection,
                deliveryTypeId = _props2.deliveryTypeId;

            var selectedItem = collection.find(function (i) {
                return i.id === deliveryTypeId;
            });
            var item = this.getSelectedDeliveryItem();
            var isSelected = !!selectedItem;
            var groupId = 'delivery_' + item.id;
            var description = selectedItem && selectedItem.description ? selectedItem.description : item.description;
            var addressRestriction = item.addressRestrictionText;

            // fuck react - it won't allow to set property allow="geolocation"
            var iframeBase = '<iframe width="100%" height="' + (window.innerHeight - 150) + 'px" title="' + Resx.App.PickupPlace_Select + '"';
            var iframe = iframeBase + ' src="' + this.props.balikovnaUrl + '" allow="geolocation" /> ';

            return _react2.default.createElement(
                'div',
                { className: 'form__radio form__radio--row no-br' },
                _react2.default.createElement('input', {
                    type: 'radio',
                    name: 'delivery',
                    id: groupId,
                    value: item.id,
                    checked: isSelected,
                    onChange: function onChange(e) {
                        return _this4.deliveryChanged(e, item.pickupPlaces);
                    }
                }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: groupId },
                    _react2.default.createElement(
                        'span',
                        { className: 'label__text' },
                        _react2.default.createElement(
                            'span',
                            null,
                            item.name
                        ),
                        isSelected && !this.isSpecialDeliveryType(item.reference) && item.pickupPlaces && item.pickupPlaces.length > 0 ? this.pickupPlaces() : this.deliveryTypes()
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'label__last' },
                        item.deliveryPrice > 0 ? (0, _linksoftAlbatros.formatPrice)(item.deliveryPrice, _linksoftAlbatros.PriceType.CartTotalPrice) : Resx.App.FreeOfCharge
                    )
                ),
                !!description && isSelected && _react2.default.createElement(_InlineTooltip2.default, { text: description, additionalText: addressRestriction }),
                _react2.default.createElement(
                    _ModalDialog2.default,
                    { key: 'balikovnaModalPopup', show: this.state.displayBalikovnaDialog,
                        dialogClassName: 'delivery-type-dialog',
                        onClose: function onClose() {
                            return _this4.showHidePickupPlaceDialog(1, false);
                        },
                        hideSubmitButton: true },
                    _react2.default.createElement('section', { dangerouslySetInnerHTML: { __html: iframe } })
                ),
                _react2.default.createElement(
                    _ModalDialog2.default,
                    { key: 'pplModalPopup', show: this.state.displayPplDialog,
                        dialogClassName: 'delivery-type-dialog ppl-delivery-dialog',
                        onClose: function onClose() {
                            return _this4.showHidePickupPlaceDialog(2, false);
                        },
                        hideSubmitButton: true },
                    _react2.default.createElement(
                        'div',
                        { className: 'box-content ppl-widget-wrapper' },
                        _react2.default.createElement('button', { title: Resx.Common.Reload, className: 'icon--refresh2 refresh-ppl',
                            onClick: function onClick() {
                                return _this4.refreshPplDialog();
                            } }),
                        _react2.default.createElement('iframe', { scrolling: window.innerHeight < 650 ? 'yes' : 'no',
                            src: this.state.pplWidgetUrl })
                    )
                )
            );
        }
    }]);
    return DeliveryTypeItem;
}(_react2.default.PureComponent), _class2.propTypes = {
    ulozenkaKey: _propTypes2.default.string,
    zasilkovnaKey: _propTypes2.default.string,
    zasilkovnaCzKey: _propTypes2.default.string,
    zasilkovnaCzDeliveryKey: _propTypes2.default.string,
    pplParcelShopKey: _propTypes2.default.string,
    balikovnaKey: _propTypes2.default.string,
    balikovnaUrl: _propTypes2.default.string,
    collection: _propTypes2.default.array.isRequired,
    paymentTypeId: _propTypes2.default.number,
    deliveryTypeId: _propTypes2.default.number,
    phoneCountryCode: _propTypes2.default.string,
    pickupPlaceId: _propTypes2.default.number,
    allowedDeliveryPayments: _propTypes2.default.array
}, _temp)) || _class);
exports.default = DeliveryTypeItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step2/DeliveryTypeItem.js
// module id = 1024
// module chunks = 0